import React from "react";
import { SESSION_MINUTES, SESSION_PRICE } from "../../../data/mentorshipData";
import { formatSlotWhen } from "../mentorshipUtils";

// Shown after Stripe sends the nurse back. `status`:
// processing (paid, waiting on our webhook) | confirmed | failed | error.
const ConfirmedCard = ({ status, mentorName, booking, onDone }) => {
  if (status === "processing") {
    return (
      <div className="ms-confirmed ms-center">
        <div className="ms-ok">
          <div className="spinner-border" role="status" />
        </div>
        <h1 className="ms-h1">Confirming your booking…</h1>
        <p className="ms-body ms-mt-8">
          Your payment went through. We&apos;re finishing up the booking now.
        </p>
      </div>
    );
  }

  if (status === "failed" || status === "error") {
    return (
      <div className="ms-confirmed ms-center">
        <h1 className="ms-h1">
          {status === "failed"
            ? "Payment wasn't completed"
            : "We couldn't confirm this booking"}
        </h1>
        <p className="ms-body ms-mt-8">
          {status === "failed"
            ? "Your card was not charged. You can try booking again."
            : "If you completed payment, check your email for a confirmation, or contact support."}
        </p>
        <button
          type="button"
          className="ms-btn ms-btn--secondary ms-btn--md ms-btn--block ms-mt-24"
          onClick={onDone}
        >
          Back to mentors
        </button>
      </div>
    );
  }

  return (
    <div className="ms-confirmed">
      <div className="ms-ok">
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M5 12l5 5L20 7" />
        </svg>
      </div>
      <h1 className="ms-h1 ms-center">You&apos;re booked</h1>
      <p className="ms-body ms-center ms-mt-8">
        Your {SESSION_MINUTES}-minute call with {mentorName} is confirmed. A
        confirmation is on its way to your email.
      </p>

      <div className="ms-card ms-summary ms-mt-24">
        <div className="ms-srow">
          <span className="k">Mentor</span>
          <span className="v">{mentorName}</span>
        </div>
        <div className="ms-srow">
          <span className="k">When</span>
          <span className="v">
            {formatSlotWhen(booking)}
          </span>
        </div>
        <div className="ms-srow">
          <span className="k">Length</span>
          <span className="v">{SESSION_MINUTES} minutes</span>
        </div>
        <div className="ms-srow">
          <span className="k">Paid</span>
          <span className="v">${SESSION_PRICE}</span>
        </div>
      </div>

      <button
        type="button"
        className="ms-btn ms-btn--ghost ms-btn--md ms-btn--block ms-mt-16"
        onClick={onDone}
      >
        Back to mentors
      </button>
    </div>
  );
};

export default ConfirmedCard;
